export default {
    mediaQuery: state => {
        let mq = [];
        if (state.widgetWidth >= 320) {
            mq.push(320);
        }
        if (state.widgetWidth >= 480) {
            mq.push(480);
        }
        if (state.widgetWidth >= 600) {
            mq.push(600);
        }
        if (state.widgetWidth >= 720) {
            mq.push(720);
        }
        if (state.widgetWidth >= 840) {
            mq.push(840);
        }
        if (state.widgetWidth >= 960) {
            mq.push(960);
        }
        if (state.widgetWidth >= 1024) {
            mq.push(1024);
        }
        if (state.widgetWidth >= 1280) {
            mq.push(1280);
        }
        if (state.widgetWidth >= 1440) {
            mq.push(1440);
        }
        if (state.widgetWidth >= 1600) {
            mq.push(1600);
        }
        if (state.widgetWidth >= 1920) {
            mq.push(1920);
        }
        return mq;
    },

    selectedPlatform: state => {
        return state.platforms.find(platform => platform.Code === state.platformCode);
    },

    selectedGroup: state => {
        return state.groups.find(group => group.Id === state.groupId);
    },

    selectedSubgroups: state => {
        return state.subgroups.filter(subgroup => state.subgroupsIds.includes(subgroup.Id));
    },

    selectedColumns: state => {
        return state.columns.filter(column => state.columnsFieldsNames.includes(column.MatchingFieldName));
    },

    arePlatformsLoading: state => {
        return !!state.platformsLoadingId;
    },

    areGroupsLoading: state => {
        return !!state.groupsLoadingId;
    },

    areSubgroupsLoading: state => {
        return !!state.subgroupsLoadingId;
    },

    areColumnsLoading: state => {
        return !!state.columnsLoadingId;
    },

    areInstrumentsLoading: state => {
        return !!state.instrumentsLoadingId;
    }
};



// WEBPACK FOOTER //
// ./src/store/getters.js